import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import i18n, { LOCALE_LABELS, LOCALES, type Locale } from '@/i18n';
import { router, usePage } from '@inertiajs/react';
import { Globe } from 'lucide-react';

export function LanguageSwitcher() {
  const locale =
    ((usePage().props as Record<string, unknown>).locale as Locale) ?? 'en';

  function switchTo(next: Locale) {
    if (next === locale) return;

    router.post(
      '/locale',
      { locale: next },
      {
        preserveScroll: true,
        // After the server saves the session locale, immediately update
        // the i18next instance so the UI re-renders in the new language
        // without requiring a full page reload.
        onSuccess: () => {
          i18n.changeLanguage(next);
        },
      },
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-1.5">
          <Globe className="h-4 w-4" />
          <span className="text-xs font-semibold uppercase">{locale}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {LOCALES.map((l) => (
          <DropdownMenuItem
            key={l}
            onClick={() => switchTo(l)}
            className={l === locale ? 'font-semibold' : ''}
          >
            {LOCALE_LABELS[l]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
